import { render } from "./ProductGroup.vue?vue&type=template&id=001da4db&scoped=true"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"

import "./ProductGroup.vue?vue&type=style&index=0&id=001da4db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001da4db"]])

export default __exports__